module.exports = __webpack_public_path__ + "9635735f73e23062b0173d28b51e4fbc.png";